module.exports = __webpack_public_path__ + "static/img/IP设计.5269f3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10003/IP设计.png
// module id = juVY
// module chunks = 1